// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import {
  MeterReadingBlockMode,
  TARIFF_TYPE
} from './../../../types/next/blocks/meterReadingBlock'
import {
  iBlockSchema,
  blockBaseSettingsSchema,
  iBlockFieldSchema
} from './baseBlock.zod'
import { unitsSchema } from './enums.zod'

export const meterReadingBlockModeSchema = z.nativeEnum(MeterReadingBlockMode)

export const tariffTypeSchema = z.nativeEnum(TARIFF_TYPE)

const meterReadingFieldsSchema = z.object({
  date: iBlockFieldSchema,
  by: iBlockFieldSchema,
  reason: iBlockFieldSchema
})

const meterConfigurationSchema = z.object({
  marketLocationId: iBlockFieldSchema,
  meterId: iBlockFieldSchema,
  counterTypeChoices: z.tuple([tariffTypeSchema]).rest(tariffTypeSchema),
  unit: unitsSchema
})

export const standardMeterReadingBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.METER_READING),
  settings: blockBaseSettingsSchema.and(
    z.object({
      mode: z.literal(MeterReadingBlockMode.STANDARD_INPUT),
      meter: meterConfigurationSchema,
      fields: meterReadingFieldsSchema
    })
  )
})

export const entityUpdatingMeterReadingBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.METER_READING),
  settings: blockBaseSettingsSchema.and(
    z.object({
      mode: z.literal(MeterReadingBlockMode.ENTITY_UPDATE),
      fields: meterReadingFieldsSchema
    })
  )
})

export const meterReadingBlockSchema = z.union([
  standardMeterReadingBlockSchema,
  entityUpdatingMeterReadingBlockSchema
])

export const meterReadingEntryValueSchema = z.object({
  maloId: z.string().optional(),
  meterId: z.string().optional(),
  meterType: tariffTypeSchema.optional(),
  readBy: z.string().optional(),
  readingDate: z.union([z.date(), z.string()]).optional().nullable(),
  readingValue: z.number().optional().nullable(),
  feedInValue: z.number().optional().nullable(),
  feedOutValue: z.number().optional().nullable(),
  ntValue: z.number().optional().nullable(),
  htValue: z.number().optional().nullable(),
  reason: z.string().optional()
})

export const meterReadingReadingSchema = z.object({
  counterId: z.string(),
  value: z.number(),
  unit: unitsSchema.optional(),
  direction: z.string(),
  _label: z.string().optional()
})

export const meterReadingDynamicEntryValueSchema = z.object({
  meterId: z.string(),
  readBy: z.string().optional(),
  readingDate: z.union([z.date(), z.string()]).optional().nullable(),
  reason: z.string().optional(),
  readings: z.array(meterReadingReadingSchema).optional(),
  _meter_number: z.string().optional()
})

export const meterReadingEntriesValueSchema = z.object({
  meters: z.array(meterReadingDynamicEntryValueSchema)
})

export const meterReadingBlockValueSchema = z.union([
  meterReadingEntryValueSchema,
  meterReadingEntriesValueSchema
])
